import {
  DEFAULT_SORT_ORDER_LICENSED_ALL,
  DEFAULT_SORT_ORDER_LICENSED_CATEGORY,
  DEFAULT_SORT_ORDER_PINKFONG_ALL,
  DEFAULT_SORT_ORDER_PINKFONG_CATEGORY
} from '../../../constants'

const state = {
  filterParams: {},
  singleFilter: {},
  sortingOrder: null,
  licensedProductsCategories: null,
  pinkfongProductsCategories: null,
  isListDeleted: false
}

const getters = {
  getFilterParams: (state) => {
    return state.filterParams
  },
  isFilterParamsEmpty: (state) => {
    if (Object.keys(state.filterParams).length === 0) {
      return true
    } else {
      return false
    }
  },
  getSingleFilter: (state) => {
    return state.singleFilter
  },
  isSingleFilterEmpty: (state) => {
    if (Object.keys(state.singleFilter).length === 0) {
      return true
    } else {
      return false
    }
  },
  getSortingOrder: (state) => {
    return state.sortingOrder
  },
  getLicensedProductsCategories: (state) => {
    return state.licensedProductsCategories
  },
  getPinkfongProductsCategories: (state) => {
    return state.pinkfongProductsCategories
  },
  isLoading: (state) => {
    return state.isLoading
  },
  isListDeleted: (state) => {
    return state.isListDeleted
  }
}

const mutations = {
  initFilterParams: (state) => {
    state.filterParams = {}
    state.sortingOrder = null
  },
  setFilterParams: (state, newParams) => {
    state.filterParams = newParams
  },
  setSingleFilter: (state, newParams) => {
    state.singleFilter = newParams
  },
  updateFilterParams: (state, newParams) => {
    const oldParams = state.filterParams
    state.filterParams = {
      ...oldParams,
      ...newParams
    }
  },
  initSortingOrder: (state, { productType, isAll }) => {
    if (productType === 'pinkfongproducts') {
      if (isAll) {
        state.sortingOrder = [ ...DEFAULT_SORT_ORDER_PINKFONG_ALL ]
      } else {
        state.sortingOrder = [ ...DEFAULT_SORT_ORDER_PINKFONG_CATEGORY ]
      }
    } else if (productType === 'licensedproducts') {
      if (isAll) {
        state.sortingOrder = [ ...DEFAULT_SORT_ORDER_LICENSED_ALL ]
      } else {
        state.sortingOrder = [ ...DEFAULT_SORT_ORDER_LICENSED_CATEGORY ]
      }
    }
  },
  setLicensedProductsCategories: (state, list) => {
    state.licensedProductsCategories = list
  },
  setPinkfongProductsCategories: (state, list) => {
    state.pinkfongProductsCategories = list
  },
  pushSortingOrder: (state, item) => {
    let index = state.sortingOrder.findIndex(x => x.type === item.type)
    while (index !== -1) {
      state.sortingOrder.splice(index, 1)
      index = state.sortingOrder.findIndex(x => x.type === item.type)
    }

    state.sortingOrder.push(item)
  },
  listDeleted: (state) => {
    state.isListDeleted = true
  },
  listRepaired: (state) => {
    state.isListDeleted = false
  }
}

const actions = {
  // getList: (payload) => {
  //   const productType = payload.productType
  //   const categoryCode = payload.categoryCode
  //   const params = payload.params
  //   const lang = payload.lang

  //   let that = this
  //   return new Promise((resolve, reject) => {
  //     that.$http.get('/api/products/' + productType + '/?lang=' + lang + '/&category=' + categoryCode, { params: params })
  //       .then(res => {
  //         resolve(res)
  //       })
  //       .catch((err) => {
  //         reject(err)
  //       })
  //   })
  // }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  state: {
    ...state
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/app/store/modules/filterParams.js